import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link, useParams } from 'react-router-dom';
import { popularComicsData } from '@/pages/home/components/PopularGrid';
import { allCategories, slugToFilterCategory, getCategoryName } from '@/utils/categories';

const comicImages: Record<string, string> = {
  'comic-1': 'https://readdy.ai/api/search-image?query=Stylized%20digital%20art%20cover%20of%20a%20Korean%20manhwa%20featuring%20a%20dark-haired%20protagonist%20with%20glowing%20blue%20eyes%20standing%20in%20a%20ruined%20cityscape%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20cool%20blue%20and%20deep%20black%20tones%2C%20painterly%20style%2C%20epic%20fantasy%20atmosphere%2C%20soft%20background%20gradient%2C%20professional%20illustration%2C%20vertical%20composition&width=600&height=800&seq=popular-comic-01&orientation=portrait',
  'comic-2': 'https://readdy.ai/api/search-image?query=Vertical%20Korean%20webtoon%20cover%20art%20of%20a%20mysterious%20young%20man%20wearing%20a%20long%20black%20coat%20reading%20an%20ancient%20glowing%20book%2C%20ethereal%20golden%20particles%20floating%20around%2C%20mystical%20library%20background%20with%20warm%20amber%20lighting%2C%20fantasy%20aesthetic%2C%20clean%20composition%2C%20soft%20dreamlike%20atmosphere%2C%20high%20quality%20digital%20painting&width=600&height=800&seq=popular-comic-02&orientation=portrait',
  'comic-3': 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20illustration%20of%20a%20handsome%20swordsman%20with%20flowing%20dark%20hair%20in%20traditional%20martial%20arts%20robes%2C%20cherry%20blossoms%20falling%20around%20him%2C%20misty%20mountain%20background%20with%20soft%20pink%20and%20sage%20green%20tones%2C%20wuxia%20fantasy%20style%2C%20elegant%20composition%2C%20delicate%20lighting%2C%20professional%20digital%20art&width=600&height=800&seq=popular-comic-03&orientation=portrait',
  'comic-4': 'https://readdy.ai/api/search-image?query=Vertical%20elegant%20Korean%20romance%20manhwa%20cover%20featuring%20a%20beautiful%20noblewoman%20in%20an%20elaborate%20Victorian-style%20dress%20with%20golden%20embroidery%2C%20standing%20in%20a%20palace%20ballroom%2C%20soft%20warm%20candlelight%20glow%2C%20rose%20gold%20and%20cream%20tones%2C%20romantic%20fantasy%20atmosphere%2C%20delicate%20face%20details%2C%20painterly%20digital%20illustration&width=600&height=800&seq=popular-comic-04&orientation=portrait',
  'comic-5': 'https://readdy.ai/api/search-image?query=Korean%20modern%20drama%20manhwa%20cover%20art%20of%20a%20confident%20businessman%20in%20a%20tailored%20suit%20standing%20in%20front%20of%20a%20glass%20skyscraper%2C%20city%20lights%20reflecting%20in%20the%20background%2C%20sophisticated%20urban%20atmosphere%2C%20cool%20grey%20and%20navy%20tones%20with%20warm%20accent%20lighting%2C%20clean%20professional%20style%2C%20high%20quality%20digital%20illustration&width=600&height=800&seq=popular-comic-05&orientation=portrait',
  'comic-6': 'https://readdy.ai/api/search-image?query=Korean%20beauty%20romance%20manhwa%20cover%20featuring%20a%20stunning%20young%20woman%20with%20flawless%20makeup%20and%20flowing%20brown%20hair%2C%20soft%20pastel%20pink%20and%20peach%20background%20with%20cherry%20blossom%20petals%2C%20warm%20gentle%20lighting%2C%20school%20uniform%20aesthetic%2C%20dreamy%20romantic%20atmosphere%2C%20clean%20digital%20art%20style&width=600&height=800&seq=popular-comic-06&orientation=portrait',
  'comic-7': 'https://readdy.ai/api/search-image?query=Korean%20fantasy%20manhwa%20cover%20of%20a%20young%20nobleman%20with%20silver%20hair%20and%20piercing%20red%20eyes%20holding%20a%20magical%20artifact%2C%20dark%20gothic%20mansion%20interior%20background%20with%20candlelight%2C%20mysterious%20royal%20atmosphere%2C%20deep%20burgundy%20and%20charcoal%20tones%2C%20elegant%20fantasy%20illustration%2C%20rich%20dramatic%20lighting&width=600&height=800&seq=popular-comic-07&orientation=portrait',
  'comic-8': 'https://readdy.ai/api/search-image?query=Korean%20action%20manhwa%20cover%20art%20of%20a%20fierce%20hunter%20wielding%20dual%20glowing%20daggers%20in%20a%20monster-filled%20dungeon%2C%20dynamic%20action%20pose%2C%20neon%20blue%20energy%20effects%2C%20dark%20cavern%20background%20with%20bioluminescent%20crystals%2C%20cool%20blue%20and%20violet%20tones%2C%20intense%20cinematic%20lighting%2C%20epic%20fantasy%20style%20digital%20painting&width=600&height=800&seq=popular-comic-08&orientation=portrait',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const categoryName = getCategoryName(slug || 'quanbu');
  const filterCategory = slugToFilterCategory[slug || ''] || null;

  const filteredComics = filterCategory
    ? popularComicsData.filter((c) => c.category === filterCategory)
    : (slug === 'paihang'
      ? [...popularComicsData].sort((a, b) => b.rating - a.rating)
      : popularComicsData);

  return (
    <>
      <Navbar />
      <main>
        <section className="relative w-full h-[360px] md:h-[440px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20warm-toned%20abstract%20illustration%20with%20soft%20golden%20and%20coral%20gradients%2C%20subtle%20book%20and%20page%20motifs%20blended%20ethereally%20into%20a%20dreamy%20background%2C%20bottom%20section%20featuring%20gentle%20silhouettes%20immersed%20in%20reading%2C%20top%20section%20open%20and%20airy%20with%20warm%20light%2C%20modern%20digital%20art%20style%2C%20editorial%20composition%2C%20harmonious%20warm%20palette%2C%20elegant%20minimalist%20aesthetic&width=1920&height=1080&seq=category-hero-2026&orientation=landscape"
            alt={`${categoryName} - 韩漫网站`}
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <nav className="flex items-center justify-center gap-2 text-sm text-white/70 mb-4">
              <Link to="/" className="hover:text-white transition-colors cursor-pointer">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-white">{categoryName}</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-5xl font-black text-white leading-tight tracking-tight mb-4">
              {categoryName}
            </h1>
            <p className="text-sm md:text-base text-white/80 max-w-xl mx-auto leading-relaxed">
              浏览{categoryName}分类下的所有韩国漫画作品，发现精彩故事
            </p>
          </div>
        </section>

        <section className="bg-background-100 py-8 md:py-12">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide">
              {allCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to="/category/all"
                  className={`flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    slug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-50 text-foreground-600 hover:bg-primary-100 hover:text-primary-500'
                  }`}
                >
                  <i className={`${cat.icon} text-base`}></i>
                  {cat.name}
                  <span className={`text-xs ml-0.5 ${
                    slug === cat.slug ? 'text-background-50/70' : 'text-foreground-400'
                  }`}>
                    {cat.count}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-background-100 pb-12 md:pb-20">
          <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
            {filteredComics.length > 0 ? (
              <div data-product-shop className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                {filteredComics.map((comic, index) => {
                  const bgColors = [
                    'bg-rose-100/40',
                    'bg-accent-100/40',
                    'bg-background-200/60',
                    'bg-secondary-100/40',
                  ];
                  const bgColor = bgColors[index % 4];

                  return (
                    <Link
                      key={comic.id}
                      to={`/comic/${comic.id}`}
                      className="group cursor-pointer"
                    >
                      <div className={`${bgColor} rounded-2xl overflow-hidden transition-transform duration-300 group-hover:scale-[1.02]`}>
                        <div className="aspect-[3/4] relative overflow-hidden">
                          <img
                            src={comicImages[comic.id]}
                            alt={comic.title}
                            title={`${comic.title} - 韩国漫画免费在线观看`}
                            className="w-full h-full object-cover object-top"
                            loading="lazy"
                          />
                          <div className="absolute top-2 right-2 px-2 py-0.5 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-primary-500">
                            {comic.rating}
                          </div>
                        </div>
                        <div className="p-3 md:p-4">
                          <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 truncate mb-1">
                            {comic.title}
                          </h3>
                          <div className="flex items-center justify-between">
                            <span className="text-xs text-foreground-500">{comic.author}</span>
                            <span className={`text-xs px-2 py-0.5 rounded-full ${
                              comic.status === '连载中'
                                ? 'bg-primary-100 text-primary-600'
                                : 'bg-accent-100 text-accent-600'
                            }`}>
                              {comic.status}
                            </span>
                          </div>
                        </div>
                      </div>
                    </Link>
                  );
                })}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-background-200 flex items-center justify-center">
                  <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-600 text-sm">该分类暂无漫画，敬请期待</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          "name": `${categoryName} - 韩漫网站`,
          "description": `浏览${categoryName}分类下的韩国漫画作品，韩漫免费在线观看下拉式阅读体验`,
          "url": 'http://bestyoungman.com/category/all',
          "isPartOf": {
            "@type": "WebSite",
            "name": "韩漫网站",
            "url": "http://bestyoungman.com/"
          },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://bestyoungman.com/" },
              { "@type": "ListItem", "position": 2, "name": categoryName, "item": 'http://bestyoungman.com/category/all' }
            ]
          }
        })}
      </script>
    </>
  );
}